import React, {useEffect, useState} from 'react'
import Video from '../../../eyeson/video'
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import RenderedHtmlContent from "../rendered_html_content";
import {useBeforeunload} from "react-beforeunload";
import {chatRouletteSetQueueState} from "../../exhibition_actions";

const ChatRoulette = () => {
  const dispatch = useDispatch()
  const chatRouletteJoinUrl = useSelector(state => state.chatRoulette?.joinUrl)
  const chatRouletteQuitUrl = useSelector(state => state.chatRoulette?.quitUrl)
  const accessToken = useSelector(state => state.chatRoulette?.access_token)
  const queueState = useSelector(state => state.chatRoulette?.queueState) || "joining_queue"
  const isBoothEditor = useSelector(state => state.isBoothEditor)

  const translations = useSelector(state => state.htmlContents || []).find(item => item.identifier == "chat_roulette.translations")?.json

  if (isBoothEditor) {
    return <div>
      Chat Roulette
    </div>
  }

  useEffect(() => {
    if (!accessToken) {
      axios.post(chatRouletteJoinUrl).then(response => {
          if (response.data.status == "OK") {
            dispatch(chatRouletteSetQueueState({queueState: response.data.state}))
          } else {
            console.error("error", response.data.errors)
            alert(response.data.errors)
          }
        },
        error => {
          alert(error)
          console.error(error)
        }
      );
    }
  }, [accessToken]);

  useEffect(() => {
    return () => {
      axios.post(chatRouletteQuitUrl)
    };
  }, []);

  const sentRemoveFromQueueBeacon = () => {
    axios.post(chatRouletteQuitUrl)
  }

  const beforeunloadHook = () => {
    if (!navigator.sendBeacon) return true;

    const headers = {type: 'application/json'};
    const blob = new Blob([JSON.stringify({})], headers);
    navigator.sendBeacon(chatRouletteQuitUrl, blob);
  }

  useBeforeunload(beforeunloadHook)

  if (accessToken) {
    return <Video accessKey={accessToken} additionalVideoClass={"embed-responsive-item"}/>
  }

  // joining_queue
  // found_match
  // already_in_queue
  // joined_queue
  // dequeued
  return <RenderedHtmlContent
    html={translations && translations[queueState] ? translations[queueState] : `Missing translation '${queueState}' in chat_roulette.translations`}/>
}

export default ChatRoulette